import {focusedAdviseSessionId} from 'hooks/chat-entry';
import WebRTC from 'services/WebRTC';
import store from 'store';
import routerHistory from 'utils/router-history';

const HANDLERS = {
  SendMessageResponse: ({body}) => {
    store.getActions().chatRoom.appendMessages({
      roomId: body.adviseSessionId,
      messages: [body.message],
    });

    if (
      document.visibilityState === 'visible' && //Otherwise handled by firebase-messaging-sw.js
      !body.message.out &&
      body.adviseSessionId !== focusedAdviseSessionId &&
      body.message.content._ !== 'Log'
    ) {
      if ('Notification' in window && Notification.permission === 'granted') {
        const notification = new Notification('شما یک پیام جدید دارید', {
          icon: '/notification-logo.png',
        });
        notification.onclick = function (event) {
          routerHistory.push(`/app/advise-sessions/${body.adviseSessionId}`);
        };
      }
    }

    if (
      body.message.content._ === 'Log' &&
      body.message.content.action._ === 'LogActionCallEnded' &&
      WebRTC.instance.signalingId === body.message.content.action.signalingId
    ) {
      WebRTC.instance.leave();
    }
  },
  UpdateMessageStatusResponse: ({body}) => {
    store.getActions().chatRoom.updateMessage({
      roomId: body.adviseSessionId,
      messageId: body.messageId,
      payload: {
        status: body.status,
      },
    });
  },
};

export function handleMessage(response, request) {
  const handler = HANDLERS[response?.body?._];
  if (handler) {
    handler(response, request);
  }
}
